import React from "react";
import { useTranslation } from "react-i18next";
import SharedChildTable from "../shared/SharedChildTable";

const ChildTable = ({
  data,
  childrenColumns,
  selectedRows,
  setSelectedRows,
  attributesPopupOpen,
  setAttributesPopupOpen,
  setCurrentTooltip,
}) => {
  return (
    <SharedChildTable
      data={data}
      childrenColumns={childrenColumns}
      selectedRows={selectedRows}
      setSelectedRows={setSelectedRows}
      popupOpen={attributesPopupOpen}
      setPopupOpen={setAttributesPopupOpen}
    />
  );
};

export default ChildTable;
